import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=bcf2a098&scoped=true&"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js&"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=bcf2a098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf2a098",
  null
  
)

export default component.exports